export function removeDataFromDataList (list, id) {
    for (let i = 0; i < list.length; i++) {
        if (list[i]._id === id) {
            list.splice(i, 1);
            return list;
        }
    } return list;
}